import { PORTFOLIO_CONTRACT_STATE } from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import { hasArchivedItems } from "web_myplann/Portfolio/Helpers/hasArchivedItems";
import { normalizePortfolioCategories } from "web_myplann/Portfolio/Helpers/normalizePortfolioCategories";
import type { AvailableCategoriesByContractState } from "web_myplann/Portfolio/Types/AvailableCategoriesByContractState";
import type { PortfolioFilterState } from "web_myplann/Shared/State/portfolioFilterAtom";

export const normalizePortfolioFilter = <
	T extends Pick<PortfolioFilterState, "categories" | "contractState">,
>(
	filter: T,
	availableByContractState: AvailableCategoriesByContractState | undefined,
): T => {
	if (!availableByContractState) {
		return filter;
	}

	const contractState = hasArchivedItems(availableByContractState)
		? filter.contractState
		: PORTFOLIO_CONTRACT_STATE.all;

	return {
		...filter,
		contractState,
		categories: normalizePortfolioCategories(
			filter.categories,
			availableByContractState[contractState],
		),
	};
};
